module.exports = __webpack_public_path__ + "static/media/tg.d37dc7bd.svg";